import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';




export default class InsertBilantBalanta extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='sm'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.props.strNume}</h2>

                    <Grid container className="container pm-dialog-textfield-container" >

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                            <InputLabel htmlFor="resursa">{this.props.limba.financiarContabil.selecteazaAnul}</InputLabel>
                            <Select

                                value={this.props.nrYear || ""}
                                onChange={this.props.changeYear }

                                input={<Input id="resursa" />}>


                                {this.props.listYears.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <FormControl className='inputFocus' style={{ width: '90%', marginTop: 20 }}>
                                <InputLabel htmlFor="resursa">{this.props.limba.financiarContabil.selecteazaLuna}</InputLabel>
                                <Select
                                    disabled={true}
                                    value={this.props.luna || ""}
                                    onChange={this.props.changeLuna}

                                    input={<Input id="resursa" />}>


                                    {this.props.listMonths.map((s, idx) => {
                                        return <MenuItem value={s.id} key={idx}  > {s.luna}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>

                    <DialogActions className="pm-dialog-bottom-buttons">

                        <Button variant="outlined" onClick={this.props.addBilantBalanta} className='pm-save-button'>
                            {this.props.limba.comune.add}
                        </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}